import { render, staticRenderFns } from "./main-content.vue?vue&type=template&id=0230582f"
import script from "./main-content.vue?vue&type=script&lang=js"
export * from "./main-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports